import { styled } from '@classify/react-core-components/styles';

import Typography from '@classify/react-core-components/Typography';
import Box from '@classify/react-core-components/Box';
import { ROUTES } from '@openclassrooms/routing';
import { translate } from '@openclassrooms/translations';

import ApplyButton from 'Modules/application/components/ApplyButton';

import Button from '@classify/react-core-components/Button';
import diplomaImageUrl from './images/diploma.svg';
import BaseBlock from '../BaseBlock';

const TextContent = styled(Box)({
  flexGrow: 1,
});

const ImageContent = styled(Box)(({ theme: { breakpoints } }) => ({
  display: 'none',
  '& > img': { width: 200 },
  [breakpoints.up('md')]: {
    display: 'flex',
    minWidth: 280,
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const List = styled(Typography)(({ theme: { spacing, typography } }) => ({
  margin: spacing(1, 0, 2, 0),
  padding: spacing(0, 0, 0, 4),
  fontWeight: typography.fontWeightMedium,
  '& > li': {
    lineHeight: spacing(4),
  },
}));
const ActionsContainer = styled(Box)(({ theme: { spacing } }) => ({
  marginTop: spacing(2),
  display: 'flex',
  flexWrap: 'wrap',
  gap: spacing(2),
}));
const BigInfoBanner = () => (
  <BaseBlock>
    <Box sx={{ display: 'flex', gap: 4 }}>
      <TextContent>
        <Typography component="div" variant="h4">
          {translate('free_user.offer_diploma.intro.title')}
        </Typography>

        <List component="ul">
          <li>{translate('free_user.offer_diploma.intro.uvp1')}</li>
          <li>{translate('free_user.offer_diploma.intro.uvp2')}</li>
          <li>{translate('free_user.offer_diploma.intro.uvp3')}</li>
          <li>{translate('free_user.offer_diploma.intro.uvp4')}</li>
        </List>

        <Typography component="div" variant="h4">
          {translate('free_user.offer_diploma.orientation.title')}
        </Typography>

        <ActionsContainer>
          <ApplyButton variant="secondary">
            {translate('free_user.offer_diploma.button_orientation')}
          </ApplyButton>
          <Button
            variant="tertiary"
            href={ROUTES.OFFERS.INDEX}
            rel="nofollow"
            data-event="Navigation|Redirection::Internal|Trainings comparison"
          >
            {translate('global.compare_offers.action')}
          </Button>
        </ActionsContainer>
      </TextContent>
      <ImageContent>
        <img alt="" src={diplomaImageUrl} />
      </ImageContent>
    </Box>
  </BaseBlock>
);

export default BigInfoBanner;
